import React, { useCallback, useContext, useState } from 'react'
import { Point } from 'assets'
import { Img } from 'styles/GlobalStyle'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { CheckPermissionStyles, FabButtonStyles } from './Style'
import { ReactComponent as RefreshPermissionIcon } from 'assets/icons/RefreshPermission.svg';
import { AnimatePresence } from "motion/react"
import { IconButton, SvgIcon } from '@mui/material'
import { microphon_off_male, microphon_off_female } from 'record1'
import ReactPlayer from 'react-player'
import * as motion from "motion/react-client"

const CheckPermissions = () => {
    const { setMicDisabled, isMaleGender } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)

    const checkPermissions = useCallback(() => {
        setCartoonSpeaking(false)
        navigator.getUserMedia = (navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);
        navigator.getUserMedia({ audio: true },
            () => {
                setMicDisabled(false)
            },
            () => {
                setCartoonSpeaking(true)
            }
        );
    }, [])

    return (
        <CheckPermissionStyles>
            <div className='wrap-cartoon-and-button'>
                <AnimatePresence>
                    <motion.div
                        exit={{ opacity: 0 }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.7 }}
                        className='cartoon-img'
                        key="cartoon-img"
                    >
                        <div className='check-permissions-img'>
                            <Img src={cartoonSpeaking ? Point : Point} />
                        </div>
                    </motion.div>
                </AnimatePresence>
                <div className='refresh-check-permissions-img'>
                    <AnimatePresence>
                        <motion.div
                            exit={{ opacity: 0 }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.7 }}
                            className='mic-img'
                            key="mic-img"
                        >
                            <div className='wrap-fab-button'>
                                <FabButtonStyles onClick={checkPermissions}>
                                    <IconButton onClick={() => { }}>
                                        <SvgIcon fontSize='small' component={RefreshPermissionIcon} inheritViewBox />
                                    </IconButton>
                                </FabButtonStyles>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
            <ReactPlayer
                playing={cartoonSpeaking}
                url={isMaleGender ? microphon_off_male : microphon_off_female}
                width='0px' height='0px'
                onEnded={() => setCartoonSpeaking(false)}
            />
        </CheckPermissionStyles >
    )
}

export default CheckPermissions